var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChartBarRegular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.75 0C2.16563 0 2.5 0.334375 2.5 0.75V13.5C2.5 13.7762 2.72375 14 3 14H17.25C17.6656 14 18 14.3344 18 14.75C18 15.1656 17.6656 15.5 17.25 15.5H3C1.89531 15.5 1 14.6047 1 13.5V0.75C1 0.334375 1.33438 0 1.75 0ZM5.5 11C5.08438 11 4.75 10.6656 4.75 10.25V7.75C4.75 7.33437 5.08438 7 5.5 7C5.91562 7 6.25 7.33437 6.25 7.75V10.25C6.25 10.6656 5.91562 11 5.5 11ZM8.75 5.75V10.25C8.75 10.6656 8.41562 11 8 11C7.58438 11 7.25 10.6656 7.25 10.25V5.75C7.25 5.33437 7.58438 5 8 5C8.41562 5 8.75 5.33437 8.75 5.75ZM10.5 11C10.0844 11 9.75 10.6656 9.75 10.25V3.75C9.75 3.33437 10.0844 3 10.5 3C10.9156 3 11.25 3.33437 11.25 3.75V10.25C11.25 10.6656 10.9156 11 10.5 11ZM13.75 6.75V10.25C13.75 10.6656 13.4156 11 13 11C12.5844 11 12.25 10.6656 12.25 10.25V6.75C12.25 6.33437 12.5844 6 13 6C13.4156 6 13.75 6.33437 13.75 6.75ZM15.5 11C15.0844 11 14.75 10.6656 14.75 10.25V4.75C14.75 4.33437 15.0844 4 15.5 4C15.9156 4 16.25 4.33437 16.25 4.75V10.25C16.25 10.6656 15.9156 11 15.5 11Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartBarRegular);
export default __webpack_public_path__ + "static/media/chart-bar-regular.1cd54b363497dcf0db525227b893fb0c.svg";
export { ForwardRef as ReactComponent };